import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    editButton: {
        marginHorizontal: Theme.BU / 2,
        alignSelf: 'center',
        maxWidth: 110
    },
    buyMoreSpaceLink: {
        color: '#31C3F7',
        fontSize: 17,
        fontFamily: Theme.regularFont
    },
    container: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        minHeight: '8%',
        padding: Theme.primaryMargin
    },
    buttonContainer: {
        flexDirection: 'row'
    }
};

export default StyleSheet.create(baseStyles);
